
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 2.27.0
 * Query Engine version: cdba6ec525e0213cce26f8e4bb23cf556d1479bb
 */
Prisma.prismaVersion = {
  client: "2.27.0",
  engine: "cdba6ec525e0213cce26f8e4bb23cf556d1479bb"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */

Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  hashedPassword: 'hashedPassword',
  reset_password_token: 'reset_password_token',
  reset_password_sent_at: 'reset_password_sent_at',
  remember_created_at: 'remember_created_at',
  sign_in_count: 'sign_in_count',
  current_sign_in_at: 'current_sign_in_at',
  last_sign_in_at: 'last_sign_in_at',
  current_sign_in_ip: 'current_sign_in_ip',
  last_sign_in_ip: 'last_sign_in_ip',
  authentication_token: 'authentication_token',
  accountEnabled: 'accountEnabled',
  role: 'role',
  smsOptIn: 'smsOptIn',
  isOrgAdmin: 'isOrgAdmin',
  organizationId: 'organizationId'
});

exports.Prisma.OrganizationScalarFieldEnum = makeEnum({
  id: 'id',
  email: 'email',
  phone: 'phone',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  schoolName: 'schoolName',
  firstName: 'firstName',
  lastName: 'lastName',
  address1: 'address1',
  address2: 'address2',
  timezone: 'timezone',
  stripeCustomerId: 'stripeCustomerId',
  mapTestingSubscriptionId: 'mapTestingSubscriptionId',
  mapTestingSubscriptionQty: 'mapTestingSubscriptionQty',
  mapTestingSubscriptionInterval: 'mapTestingSubscriptionInterval',
  mapAcceleratorSubscriptionId: 'mapAcceleratorSubscriptionId',
  mapAcceleratorSubscriptionInterval: 'mapAcceleratorSubscriptionInterval',
  batchRosterId: 'batchRosterId',
  orgAdminUserId: 'orgAdminUserId'
});

exports.Prisma.StudentScalarFieldEnum = makeEnum({
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  birthdate: 'birthdate',
  grade: 'grade',
  gender: 'gender',
  mapAcceleratorSection: 'mapAcceleratorSection',
  mapFluencyEnrollment: 'mapFluencyEnrollment',
  mapFluencySection: 'mapFluencySection',
  mindprintEnrollment: 'mindprintEnrollment',
  mindprintEncryptedPassword: 'mindprintEncryptedPassword',
  schoolId: 'schoolId',
  organizationId: 'organizationId',
  defaultRosterId: 'defaultRosterId'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  handle: 'handle',
  hashedSessionToken: 'hashedSessionToken',
  antiCSRFToken: 'antiCSRFToken',
  publicData: 'publicData',
  privateData: 'privateData',
  userId: 'userId'
});

exports.Prisma.TokenScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  sentTo: 'sentTo',
  userId: 'userId'
});

exports.Prisma.BookingScalarFieldEnum = makeEnum({
  id: 'id',
  startAt: 'startAt',
  endAt: 'endAt',
  phoneNumber: 'phoneNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  timekitId: 'timekitId',
  previousTimekitId: 'previousTimekitId',
  resourceId: 'resourceId',
  subject: 'subject',
  status: 'status',
  orderGroupId: 'orderGroupId',
  organizationId: 'organizationId'
});

exports.Prisma.BookingOrderScalarFieldEnum = makeEnum({
  bookingId: 'bookingId',
  orderId: 'orderId',
  id: 'id'
});

exports.Prisma.OrderScalarFieldEnum = makeEnum({
  id: 'id',
  organizationId: 'organizationId',
  wp_order_id: 'wp_order_id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stripeTransactionId: 'stripeTransactionId',
  amount: 'amount',
  chargeStatus: 'chargeStatus',
  orderGroupId: 'orderGroupId',
  addons: 'addons',
  status: 'status',
  fromBatch: 'fromBatch',
  changeOrderId: 'changeOrderId'
});

exports.Prisma.TestCreditScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  description: 'description',
  orderId: 'orderId',
  organizationId: 'organizationId'
});

exports.Prisma.TestScalarFieldEnum = makeEnum({
  id: 'id',
  bookingId: 'bookingId',
  studentId: 'studentId',
  gradeLevel: 'gradeLevel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  textToSpeech: 'textToSpeech',
  accommodations: 'accommodations',
  level: 'level',
  subject: 'subject',
  status: 'status',
  orderId: 'orderId',
  organizationId: 'organizationId',
  makeupOrderId: 'makeupOrderId'
});

exports.Prisma.OrderGroupScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  uuid: 'uuid',
  name: 'name',
  size: 'size',
  website: 'website',
  canListWebsite: 'canListWebsite',
  includeLanguage: 'includeLanguage',
  includeScience: 'includeScience',
  includeSpReading: 'includeSpReading',
  includeSpMath: 'includeSpMath',
  organizationId: 'organizationId'
});

exports.Prisma.PriceScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  public: 'public',
  value: 'value',
  orgAdminUserId: 'orgAdminUserId'
});

exports.Prisma.ProcessedReportScalarFieldEnum = makeEnum({
  id: 'id',
  testName: 'testName',
  studentId: 'studentId',
  testStartDate: 'testStartDate',
  reportId: 'reportId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId'
});

exports.Prisma.TestResultScalarFieldEnum = makeEnum({
  id: 'id',
  encryptedFile: 'encryptedFile',
  unencryptedFile: 'unencryptedFile',
  studentName: 'studentName',
  reportId: 'reportId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  studentId: 'studentId',
  data: 'data',
  termName: 'termName',
  organizationId: 'organizationId'
});

exports.Prisma.TestResultRawScalarFieldEnum = makeEnum({
  id: 'id',
  reportId: 'reportId',
  studentName: 'studentName',
  studentId: 'studentId',
  normsReferenceData: 'normsReferenceData',
  termName: 'termName',
  subject: 'subject',
  course: 'course',
  grade: 'grade',
  rit: 'rit',
  percentile: 'percentile',
  goal1Name: 'goal1Name',
  goal1Adjective: 'goal1Adjective',
  goal2Name: 'goal2Name',
  goal2Adjective: 'goal2Adjective',
  goal3Name: 'goal3Name',
  goal3Adjective: 'goal3Adjective',
  goal4Name: 'goal4Name',
  goal4Adjective: 'goal4Adjective',
  lexileMin: 'lexileMin',
  lexileMax: 'lexileMax',
  testStartDate: 'testStartDate',
  organizationId: 'organizationId'
});

exports.Prisma.ReportScalarFieldEnum = makeEnum({
  id: 'id',
  file: 'file',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId'
});

exports.Prisma.TermAgreementScalarFieldEnum = makeEnum({
  id: 'id',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type'
});

exports.Prisma.OrderVoucherScalarFieldEnum = makeEnum({
  voucherId: 'voucherId',
  orderId: 'orderId',
  id: 'id'
});

exports.Prisma.CouponOrderScalarFieldEnum = makeEnum({
  couponId: 'couponId',
  orderId: 'orderId',
  id: 'id'
});

exports.Prisma.VoucherScalarFieldEnum = makeEnum({
  id: 'id',
  code: 'code',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  initialValue: 'initialValue',
  remainingValue: 'remainingValue',
  pendingRemainingValue: 'pendingRemainingValue',
  externalOrderNumber: 'externalOrderNumber',
  externalOrderFulfilled: 'externalOrderFulfilled'
});

exports.Prisma.CouponScalarFieldEnum = makeEnum({
  id: 'id',
  code: 'code',
  enabled: 'enabled',
  deleted: 'deleted',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  value: 'value',
  type: 'type'
});

exports.Prisma.RosterScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  code: 'code',
  phone: 'phone',
  password: 'password',
  regionId: 'regionId'
});

exports.Prisma.RosterAssignmentScalarFieldEnum = makeEnum({
  id: 'id',
  rosterId: 'rosterId',
  bookingId: 'bookingId',
  proctorId: 'proctorId',
  regionId: 'regionId'
});

exports.Prisma.ScheduleBlockScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startAt: 'startAt',
  endAt: 'endAt'
});

exports.Prisma.SchoolScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  address: 'address',
  city: 'city',
  state: 'state',
  zip: 'zip',
  hostname: 'hostname',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  defaultRosterId: 'defaultRosterId'
});

exports.Prisma.PrivateSchoolRegistrationScalarFieldEnum = makeEnum({
  id: 'id',
  schoolName: 'schoolName',
  contactName: 'contactName',
  contactTitle: 'contactTitle',
  contactEmail: 'contactEmail',
  contactPhone: 'contactPhone',
  gradeK: 'gradeK',
  grade1: 'grade1',
  grade2: 'grade2',
  grade3: 'grade3',
  grade4: 'grade4',
  grade5: 'grade5',
  grade6: 'grade6',
  grade7: 'grade7',
  grade8: 'grade8',
  grade9: 'grade9',
  grade10: 'grade10',
  grade11: 'grade11',
  grade12: 'grade12',
  numOfGradeKStudents: 'numOfGradeKStudents',
  numOfGrade1Students: 'numOfGrade1Students',
  numOfGrade2Students: 'numOfGrade2Students',
  numOfGrade3Students: 'numOfGrade3Students',
  numOfGrade4Students: 'numOfGrade4Students',
  numOfGrade5Students: 'numOfGrade5Students',
  numOfGrade6Students: 'numOfGrade6Students',
  numOfGrade7Students: 'numOfGrade7Students',
  numOfGrade8Students: 'numOfGrade8Students',
  numOfGrade9Students: 'numOfGrade9Students',
  numOfGrade10Students: 'numOfGrade10Students',
  numOfGrade11Students: 'numOfGrade11Students',
  numOfGrade12Students: 'numOfGrade12Students',
  studentsTesting: 'studentsTesting',
  reading: 'reading',
  math: 'math',
  science: 'science',
  language: 'language',
  fall: 'fall',
  winter: 'winter',
  spring: 'spring',
  otherQuestions: 'otherQuestions',
  createdAt: 'createdAt'
});

exports.Prisma.TestFluencyResultsRawScalarFieldEnum = makeEnum({
  id: 'id',
  termName: 'termName',
  studentId: 'studentId',
  studentName: 'studentName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  grade: 'grade',
  reportId: 'reportId',
  organizationId: 'organizationId',
  assignedTestType: 'assignedTestType',
  resultType: 'resultType',
  testLanguage: 'testLanguage',
  testCompletionDate: 'testCompletionDate',
  listeningComprehensionCorrect: 'listeningComprehensionCorrect',
  listeningComprehensionAttempted: 'listeningComprehensionAttempted',
  listeningComprehensionPerformanceLevel: 'listeningComprehensionPerformanceLevel',
  pictureVocabCorrect: 'pictureVocabCorrect',
  pictureVocabAttempted: 'pictureVocabAttempted',
  pictureVocabPerformanceLevel: 'pictureVocabPerformanceLevel',
  phonologicalAwarenessDomainScore: 'phonologicalAwarenessDomainScore',
  phonologicalAwarenessTestPercentile: 'phonologicalAwarenessTestPercentile',
  phonologicalAwarenessZPDName: 'phonologicalAwarenessZPDName',
  phonologicalAwarenessZPDLevel: 'phonologicalAwarenessZPDLevel',
  phonologicalAwarenessPerformanceLevel: 'phonologicalAwarenessPerformanceLevel',
  phonicsWordRecognitionDomainScore: 'phonicsWordRecognitionDomainScore',
  phonicsWordRecognitionTestPercentile: 'phonicsWordRecognitionTestPercentile',
  phonicsWordRecognitionZPDName: 'phonicsWordRecognitionZPDName',
  phonicsWordRecognitionZPDLevel: 'phonicsWordRecognitionZPDLevel',
  phonicsWordRecognitionPerformanceLevel: 'phonicsWordRecognitionPerformanceLevel',
  languageComprehensionDomainScore: 'languageComprehensionDomainScore',
  languageComprehensionTestPercentile: 'languageComprehensionTestPercentile',
  sentenceReadingFluencyCorrect: 'sentenceReadingFluencyCorrect',
  sentenceReadingFluencyAttempted: 'sentenceReadingFluencyAttempted',
  sentenceReadingFluencyPerformanceLevel: 'sentenceReadingFluencyPerformanceLevel',
  oralReadingRatePerformanceLevel: 'oralReadingRatePerformanceLevel',
  oralReadingWCPMScaled: 'oralReadingWCPMScaled',
  oralReadingAccuracyPerformanceLevel: 'oralReadingAccuracyPerformanceLevel',
  oralReadingAccuracyScore: 'oralReadingAccuracyScore',
  literalComprehensionPerformanceLevel: 'literalComprehensionPerformanceLevel',
  lexileOralReadingMeasure: 'lexileOralReadingMeasure',
  dyslexiaScreenerOutcome: 'dyslexiaScreenerOutcome',
  ranDurationOverallScore: 'ranDurationOverallScore',
  ranPicturesCorrectPerSecondOverallScore: 'ranPicturesCorrectPerSecondOverallScore',
  ranDurationPage1: 'ranDurationPage1',
  ranPicturesCorrectPerSecondPage1: 'ranPicturesCorrectPerSecondPage1',
  ranDurationPage2: 'ranDurationPage2',
  ranPicturesCorrectPerSecondPage2: 'ranPicturesCorrectPerSecondPage2',
  universalScreenerOutcome: 'universalScreenerOutcome'
});

exports.Prisma.SessionProgressScalarFieldEnum = makeEnum({
  id: 'id',
  sessionName: 'sessionName',
  studentId: 'studentId',
  lastName: 'lastName',
  firstName: 'firstName',
  status: 'status',
  question: 'question',
  testAssignment: 'testAssignment',
  accomodations: 'accomodations',
  rapidGuesses: 'rapidGuesses',
  rapidGuessPercent: 'rapidGuessPercent',
  reachedRapidGuessingThreshold: 'reachedRapidGuessingThreshold',
  testDuration: 'testDuration',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.SystemValuesScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  code: 'code',
  value: 'value',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.ProctorRegionScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name'
});

exports.Prisma.StateRegionAssignmentScalarFieldEnum = makeEnum({
  id: 'id',
  regionId: 'regionId',
  stateAbbrev: 'stateAbbrev'
});

exports.Prisma.DailyRegionAssignmentScalarFieldEnum = makeEnum({
  id: 'id',
  regionId: 'regionId',
  date: 'date',
  createdAt: 'createdAt'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});
exports.Role = makeEnum({
  SUPERADMIN: 'SUPERADMIN',
  ADMIN: 'ADMIN',
  PROCTOR: 'PROCTOR',
  CUSTOMER: 'CUSTOMER'
});

exports.Gender = makeEnum({
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  THEY: 'THEY'
});

exports.TokenType = makeEnum({
  CHANGE_EMAIL: 'CHANGE_EMAIL',
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  RESET_PASSSWORD: 'RESET_PASSSWORD',
  INVITE_ORG_LINK: 'INVITE_ORG_LINK'
});

exports.TestSubject = makeEnum({
  LANGUAGE: 'LANGUAGE',
  MATH: 'MATH',
  READING: 'READING',
  SCIENCE: 'SCIENCE',
  SCREENING: 'SCREENING',
  FLUENCY: 'FLUENCY',
  MINDPRINT: 'MINDPRINT',
  SP_READING: 'SP_READING',
  SP_MATH: 'SP_MATH'
});

exports.BookingStatus = makeEnum({
  UNCONFIRMED: 'UNCONFIRMED',
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED'
});

exports.OrderStatus = makeEnum({
  DRAFT: 'DRAFT',
  ABANDONED: 'ABANDONED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
  SUCCESS: 'SUCCESS',
  CHANGE_ORDER: 'CHANGE_ORDER'
});

exports.TestStatus = makeEnum({
  CANCELED: 'CANCELED',
  CHECKED_IN: 'CHECKED_IN',
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  NEEDS_RESCHEDULED: 'NEEDS_RESCHEDULED',
  SCHEDULED: 'SCHEDULED'
});

exports.AgreementType = makeEnum({
  HOMESCHOOL_PARENT: 'HOMESCHOOL_PARENT',
  GROUP_ENTITY: 'GROUP_ENTITY'
});

exports.CouponType = makeEnum({
  AMOUNT: 'AMOUNT',
  PERCENT: 'PERCENT'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Organization: 'Organization',
  Student: 'Student',
  Session: 'Session',
  Token: 'Token',
  Booking: 'Booking',
  BookingOrder: 'BookingOrder',
  Order: 'Order',
  TestCredit: 'TestCredit',
  Test: 'Test',
  OrderGroup: 'OrderGroup',
  Price: 'Price',
  ProcessedReport: 'ProcessedReport',
  TestResult: 'TestResult',
  TestResultRaw: 'TestResultRaw',
  Report: 'Report',
  TermAgreement: 'TermAgreement',
  OrderVoucher: 'OrderVoucher',
  CouponOrder: 'CouponOrder',
  Voucher: 'Voucher',
  Coupon: 'Coupon',
  Roster: 'Roster',
  RosterAssignment: 'RosterAssignment',
  ScheduleBlock: 'ScheduleBlock',
  School: 'School',
  PrivateSchoolRegistration: 'PrivateSchoolRegistration',
  TestFluencyResultsRaw: 'TestFluencyResultsRaw',
  SessionProgress: 'SessionProgress',
  SystemValues: 'SystemValues',
  ProctorRegion: 'ProctorRegion',
  StateRegionAssignment: 'StateRegionAssignment',
  DailyRegionAssignment: 'DailyRegionAssignment'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
